export enum Avatars {
  ALTERMAIND = 'altermaind',
  AVATAR3D = 'avatar3d',
}
